import { useState } from "react";
import { ArrowLeft, KeyRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import "./Auth.css";

export default function ResetPasswordPage() {
  const { resetPassword, formatApiError } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const token = new URLSearchParams(window.location.search).get("token") || "";

  const submit = async (event) => {
    event.preventDefault();
    setError(""); setMessage("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    try { const result = await resetPassword({ token, password }); setMessage(result.message); }
    catch (err) { setError(formatApiError(err)); }
  };

  return <main className="ns-auth-page" data-testid="reset-password-page"><div className="ns-auth-card"><p className="ns-kicker"><KeyRound size={14} /> Secure reset</p><h1>Create a new<br /><em>password.</em></h1><form onSubmit={submit}><input data-testid="reset-password-input" type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} required /><input data-testid="reset-confirm-input" type="password" placeholder="Confirm password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />{error && <p className="ns-form-error">{error}</p>}{message && <p className="ns-form-success">{message}</p>}<button className="ns-button ns-button-primary" data-testid="reset-submit-button">Update password</button></form><a href="/" data-testid="reset-home-link"><ArrowLeft size={15} /> Back to the magical world</a></div></main>;
}
